import React, {Component} from 'react';
import './styles.css';
import {logout} from '../../actions/authentication';
import {updateUser} from '../../actions/users';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';
import PropTypes from 'prop-types';

const TITLES = [
    {match: /^\/$/,         title: 'Home',        sub: 'Your vacation balance and holidays'},
    {match: /^\/myreports/, title: 'My Reports',  sub: 'Log your monthly project work'},
    {match: /^\/vacation$/, title: 'My Vacations',sub: 'Request and track your time off'},
    {match: /^\/calendar/,  title: 'Calendar',    sub: 'Team vacations and holidays'},
    {match: /^\/reports/,   title: 'Reports',     sub: 'Download project reports'},
    {match: /^\/vacations/, title: 'Vacations',   sub: 'Review and approve requests'},
    {match: /^\/projects/,  title: 'Projects',    sub: 'Manage projects'},
    {match: /^\/users/,     title: 'Users',       sub: 'Manage team members'},
    {match: /^\/holidays/,  title: 'Holidays',    sub: 'Manage official holidays'},
];

const DEFAULT_STATE = {
    open: false,
    menuOpen: false,
    password1: '',
    password2: '',
};

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onSignOut = this._onSignOut.bind(this);
        this._onCloseChangePassword = this._onCloseChangePassword.bind(this);
        this._onChangeInput = this._onChangeInput.bind(this);
        this._onClickChangePassword = this._onClickChangePassword.bind(this);
        this._onClickOpenChangePassword = this._onClickOpenChangePassword.bind(this);
        this._toggleMenu = this._toggleMenu.bind(this);
        this._onDocClick = this._onDocClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this._onDocClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._onDocClick);
    }

    _onDocClick(event) {
        if (this.state.menuOpen && this._menuRef && !this._menuRef.contains(event.target)) {
            this.setState({menuOpen: false});
        }
    }

    _toggleMenu() {
        this.setState({menuOpen: !this.state.menuOpen});
    }

    _onSignOut() {
        this.props.dispatch(logout());
        this.props.history.push('/login');
    }

    _onCloseChangePassword() {
        this.setState({open: false, password1: '', password2: ''});
    }

    _onChangeInput(property, event) {
        this.setState({[property]: event.target.value});
    }

    _onClickChangePassword() {
        this.props.dispatch(updateUser((error, json) => {
            if (!error) {
                this._onCloseChangePassword();
            }
        }, this.props.user._id, {password: this.state.password1}));
    }

    _onClickOpenChangePassword() {
        this.setState({open: true, menuOpen: false});
    }

    render() {
        const user = this.props.user || {};
        const initials = ((user.firstName || ' ')[0] + (user.lastName || ' ')[0]).toUpperCase().trim() || 'U';
        const pathname = (this.props.location && this.props.location.pathname) || '/';
        const meta = TITLES.find(t => t.match.test(pathname)) || {title: 'Portal', sub: ''};

        let disabled = !((this.state.password1.length > 5) && (this.state.password2 === this.state.password1));

        return (
            <header className="Topbar">
                <button className="Hamburger" onClick={this.props.onToggleSidebar} aria-label="Open menu">
                    <i className="fa fa-bars" aria-hidden="true" />
                </button>

                <div className="Topbar-Title">
                    {meta.title}
                    <span className="sub">{meta.sub}</span>
                </div>

                <div className="Topbar-Spacer" />

                <div className="User-Menu" ref={ref => this._menuRef = ref}>
                    <button className="User-Trigger" onClick={this._toggleMenu} aria-haspopup="true" aria-expanded={this.state.menuOpen}>
                        <span className="Avatar">{initials}</span>
                        <span className="u-name">{user.firstName || 'Account'}</span>
                        <i className="fa fa-angle-down caret-ico" aria-hidden="true" />
                    </button>

                    {this.state.menuOpen &&
                        <div className="User-Dropdown">
                            <div className="dd-head">
                                <div className="n">{(user.firstName || '') + ' ' + (user.lastName || '')}</div>
                                <div className="e">{user.email || ''}</div>
                            </div>
                            <button onClick={this._onClickOpenChangePassword}>
                                <i className="fa fa-key" aria-hidden="true" /> Change password
                            </button>
                            <button className="danger" onClick={this._onSignOut}>
                                <i className="fa fa-sign-out" aria-hidden="true" /> Log out
                            </button>
                        </div>
                    }
                </div>

                <Modal open={this.state.open} onClose={this._onCloseChangePassword} little>
                    <div className="Modal-Head">
                        <h4>Change password</h4>
                        <div className="sub">Use at least 6 characters.</div>
                    </div>
                    <div className="Modal-Body">
                        <div className="Input-Group">
                            <label>New password</label>
                            <input type="password" className="form-control"
                                   value={this.state.password1}
                                   onChange={event => this._onChangeInput('password1', event)}
                            />
                        </div>
                        <div className="Input-Group">
                            <label>Confirm password</label>
                            <input type="password" className="form-control"
                                   value={this.state.password2}
                                   onChange={event => this._onChangeInput('password2', event)}
                            />
                        </div>
                    </div>
                    <div className="Modal-Foot">
                        <button type="button" className="btn btn-default" onClick={this._onCloseChangePassword}>Cancel</button>
                        <button disabled={disabled} type="button" className="btn btn-primary"
                                onClick={this._onClickChangePassword}>Save password</button>
                    </div>
                </Modal>
            </header>
        );
    }
}

Header.propTypes = {
    user: PropTypes.object,
};

Header.defaultProps = {
    user: {},
};

function mapStateToProps(state) {
    return {user: state.authentication.user};
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js